import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { Card } from '../../ui/Card';
import { RARITY_CONFIG } from '../../../mascot/achievements/achievementData';
import { RarityDjayWrapper } from './RarityDjayWrapper';
import { useAchievementShimmer } from './useAchievementShimmer';
import { AchievementProgressBar } from './AchievementProgressBar';
import type { AchievementCardProps } from './types';
export function AchievementCard({
  achievement,
  isUnlocked,
  index
}: AchievementCardProps) {
  const isNewlySeen = useAchievementShimmer(achievement.id, isUnlocked);
  const config = RARITY_CONFIG[achievement.rarity];
  const isHighlightRarity = achievement.rarity === 'rare' || achievement.rarity === 'legendary';
  const djayEmotion = isUnlocked ? achievement.djayEmotionUnlocked : achievement.djayEmotionLocked;
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.02
  }} className="relative h-full" data-id="element-1801" data-mp="1i1pgqcotpiui">
      
      <Card className={`
          relative overflow-hidden p-3 transition-all duration-300 border-2 h-full flex flex-col
          ${isUnlocked ? `${config.cardBg} ${config.cardBorder} shadow-sm` : 'bg-slate-50 border-slate-200 opacity-70'}
          ${isUnlocked ? 'hover:shadow-md hover:-translate-y-0.5' : ''}
          ${isNewlySeen ? 'animate-shine' : ''}
        `} style={isNewlySeen ? {
      animationIterationCount: 1
    } : undefined} data-id="element-1802" data-mp="2ma28fet05dmd">
        
        {!isUnlocked && <div className="absolute top-2 right-2 z-10" data-id="element-1803" data-mp="1yk7uetwy5j0j">
            <div className="w-5 h-5 rounded-full bg-slate-200 flex items-center justify-center shadow-inner" data-id="element-1804" data-mp="1tm6f8k2n63uc">
              <Lock className="w-3 h-3 text-slate-400" data-id="element-1805" data-mp="1onblin34yuvg" />
            </div>
          </div>}

        {isUnlocked && isHighlightRarity && <div className="absolute top-2 right-2 z-10" data-id="element-1806" data-mp="3nz4kuqdeccbc">
            <div className={`px-1.5 py-0.5 rounded-full text-[9px] font-bold shadow-sm ${config.badgeBg} ${config.badgeText}`} data-id="element-1807" data-mp="3j1344c3g0p31">
            
              {config.label}
            </div>
          </div>}

        <div className="flex items-start gap-3 relative z-10 flex-1" data-id="element-1808" data-mp="1m2ndwxpj5nwy">
          <div className="flex-shrink-0" data-id="element-1809" data-mp="1m3yhawf2ctnj">
            <RarityDjayWrapper rarity={achievement.rarity} emotion={djayEmotion} variant={achievement.djayVariantUnlocked} accessory={achievement.accessory} isUnlocked={isUnlocked} animate={isUnlocked} data-id="element-1810" data-mp="17e9d0sboc9j1" />
            
          </div>

          <div className="flex-1 min-w-0 pt-0.5 flex flex-col h-full" data-id="element-1811" data-mp="203pzl9cm4w7c">
            <div className="flex items-center gap-1.5 mb-1" data-id="element-1812" data-mp="252189gr690nz">
              <span className="text-base" data-id="element-1813" data-mp="24z5dg1ames3r">{achievement.emoji}</span>
              <h4 className={`font-black text-xs truncate ${isUnlocked ? 'text-slate-800' : 'text-slate-600'}`} data-id="element-1814" data-mp="1r1708z81d1pu">
                
                {achievement.name}
              </h4>
            </div>
            <p className={`text-[10px] leading-snug mb-2 flex-1 ${isUnlocked ? config.textColor : 'text-slate-500'}`} data-id="element-1815" data-mp="fl08gmu20g5i">
              
              {achievement.description}
            </p>

            {!isUnlocked && achievement.progress && <div className="mt-auto pt-1" data-id="element-1816" data-mp="c6gw4lry022y">
                <AchievementProgressBar current={achievement.progress.current} max={achievement.progress.max} layout="labelled" size="thin" data-id="element-1817" data-mp="74j3x21kdwxv" />
              
              </div>}
          </div>
        </div>
      </Card>
    </motion.div>;
}